import { AxiosError } from 'axios'
import { get } from 'lodash'
import { useQuery } from 'react-query'

import { Meta } from '@/features/filters/types'
import { fetchAPI } from '@/lib/api'

import { VISIBLE_ECOS } from '../constants'
import { VisibleEcosResponse } from '../types'

type VisibleEcosType = {
  data: VisibleEcosResponse[]
  meta: Meta
}

const getVisibleEcos = async (params: Meta): Promise<VisibleEcosType> => {
  const response = await fetchAPI({
    path: `/visible_ecos`,
    params,
  })

  const data = get(response, 'data.visible_ecos', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const useGetVisibleEcos = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: VisibleEcosType
}) => {
  return useQuery<VisibleEcosType, AxiosError>({
    queryKey: [VISIBLE_ECOS, params],
    queryFn: () => getVisibleEcos(params),
    keepPreviousData: true,
    initialData,
  })
}
